import React from 'react';
import PropTypes from 'prop-types';

import CollectionFee from "./CollectionFee";
import ShowAllTable from "./ShowAllTable";


class CollectionFeeSettingTable extends React.Component {

  state = {
    showAll : false,
    calculateToDate : this.props.calculateToDate
  };

  constructor(props){
    super(props);
    this.showTableClick = this.showTableClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ calculateToDate: nextProps.calculateToDate });
  }


  showTableClick(showAll){
    this.setState({ showAll: showAll });
  };

  isDateInRange(itemNumber){
    let collectionFees = this.props.data.collectionFees;
    let item = collectionFees[itemNumber];
    if (itemNumber+1 < collectionFees.length)
    {
      let nextItem = collectionFees[itemNumber+1];
      if ((this.state.calculateToDate < nextItem.validFromDate) && (this.state.calculateToDate >= item.validFromDate)){
        return true;
      }
    }
    else if (this.state.calculateToDate >= item.validFromDate){
      return true;
    }
    return false;
  };

  render() {
    if (!this.props.data.collectionFees){
      return (
        <div/>
      );
    }

    let collectionFees = this.props.data.collectionFees;
    return (
      <div className="calc-setting-table">
        <table className="table">
          <colgroup>
            <col />
            <col />
            <col />
          </colgroup>
          <thead>
          <tr>
            <th colSpan="3" className="text-left calc-setting-table-header">Innheimtulaun</th>
          </tr>
          </thead>
        </table>
        {collectionFees.map((item,i) => {
          return(
            <div key={i}>
              {(!this.state.showAll && this.isDateInRange(i)) && <CollectionFee data={item} highligh={false} />}
              {(this.state.showAll) && <CollectionFee data={item} highligh={this.isDateInRange(i)} />}
            </div>)
        })}
        <ShowAllTable showAll={this.state.showAll} numberOfColumns={3} handleShowHideClick={this.showTableClick}/>
      </div>
    );
  }
}

CollectionFeeSettingTable.propTypes = {
  data : PropTypes.object,
  calculateToDate: PropTypes.object
};



export default CollectionFeeSettingTable;



// WEBPACK FOOTER //
// ./src/pages/Calculation/Settings/CollectionFeeSettingTable.js